<template>
  <div class="betting-container">
    <div class="inline-wrapper bettinfo-date">
      <div class="date-left">
        <el-radio-group v-model="fastData" @change="fastDataChange">
          <el-radio-button label="Today" :class="{'is-active': firstActive}"></el-radio-button>
          <el-radio-button label="3 days"></el-radio-button>
          <el-radio-button label="7 days"></el-radio-button>
        </el-radio-group>
        <el-date-picker
          v-model="freeDate"
          type="daterange"
          range-separator="-"
          start-placeholder="Start Time"
          end-placeholder="End Time"
          format="yyyy-MM-dd"
          value-format="timestamp"
          :default-time="['00:00:00', '23:59:59']"
          :clearable="false"
          :unlink-panels="true"
          @change="dataTimeChange"
        ></el-date-picker>
      </div>
      <div class="inline-right date-right">Statistics are based on GMT-4</div>
    </div>
    <div class="card-tabs-wrapper">
      <el-tabs type="card" v-model="queryData.keyType" @tab-click="handleClick">
        <el-tab-pane label="Total" name="1"></el-tab-pane>
        <el-tab-pane label="Sport Ranking" name="2"></el-tab-pane>
        <el-tab-pane label="Tournament Ranking" name="3"></el-tab-pane>
        <el-tab-pane label="Market Ranking" name="4"></el-tab-pane>
        <el-tab-pane label="Pre-match/Live" name="5"></el-tab-pane>
        <el-tab-pane label="Order Risk Tag" name="7"></el-tab-pane>
        <el-tab-pane label="Bet Device" name="6"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="middle-btn" v-if="queryData.keyType == 1">
      <el-button
        class="lebel-risk-export-btn betType-btn"
        :class="{'betType-btn-active': queryData.seriesType == null}"
        @click="handleTotal(null)"
      >Total</el-button>
      <el-button
        class="lebel-risk-export-btn betType-btn"
        :class="{'betType-btn-active': queryData.seriesType == 0}"
        @click="handleTotal(0)"
      >Total-Single</el-button>
      <el-button
        class="lebel-risk-export-btn betType-btn"
        :class="{'betType-btn-active': queryData.seriesType == 1}"
        @click="handleTotal(1)"
      >Total-Parlay</el-button>
    </div>
    <div v-if="queryData.keyType == 1">
      <el-table
        ref="table"
        :data="list"
        :summary-method="getSummaries"
        show-summary
        :height="tableHeight"
        v-loading="loading"
        :key="1"
        header-row-class-name="table-header-row"
        border
      >
        <template slot="empty">
          <Empty />
        </template>
        <el-table-column label="Time" prop="content" min-width="122" class-name="table-font-bold"></el-table-column>
        <el-table-column label="Stake" sortable prop="totalStake" align="right" min-width="113">
          <template v-slot="{ row }">
            <div>{{formatAmount(row.totalStake)}}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="Settled Stake"
          sortable
          prop="totalSettleStake"
          align="right"
          min-width="113"
        >
          <template v-slot="{ row }">
            <div>{{formatAmount(row.totalSettleStake)}}</div>
          </template>
        </el-table-column>
        <el-table-column label="P/L" sortable prop="totalProfit" align="right" min-width="113">
          <template v-slot="{ row }">
            <div>{{formatAmount(row.totalProfit)}}</div>
          </template>
        </el-table-column>
        <el-table-column label="P/L%" sortable align="right" prop="profitRate" min-width="113">
          <template v-slot="{ row }">
            <div>{{row.profitRate}}%</div>
          </template>
        </el-table-column>
        <el-table-column label="Bets" sortable prop="orderCount" align="right" min-width="115">
          <template v-slot="{ row }">
            <div>{{formatAmount(row.orderCount)}}</div>
          </template>
        </el-table-column>
        <el-table-column label="Info Bets" prop="infoOrderCount" align="right" min-width="113"></el-table-column>
        <el-table-column label="Max Stake Bets" prop="maxStakeCount" align="right" min-width="125"></el-table-column>
        <el-table-column
          label="Max Stake Percent"
          align="right"
          prop="maxStakePercent"
          min-width="145"
        >
          <template v-slot="{ row }">
            <div>{{row.maxStakePercent}}%</div>
          </template>
        </el-table-column>
        <el-table-column label="Cashout Stake" prop="cashOutStake" align="right" min-width="125">
          <template v-slot="{ row }">
            <div>{{formatAmount(row.cashOutStake)}}</div>
          </template>
        </el-table-column>
        <el-table-column label="Cashout P/L" prop="cashOutProfit" align="right" min-width="125">
          <template v-slot="{ row }">
            <div>{{formatAmount(row.cashOutProfit)}}</div>
          </template>
        </el-table-column>
        <el-table-column label="Bet Count" prop="betCount" align="right" min-width="119"></el-table-column>
        <el-table-column label="Cashout Bets" prop="cashOutCount" align="right" min-width="128"></el-table-column>
        <el-table-column label="Average Stake" prop="avgStake" align="right" min-width="124">
          <template v-slot="{ row }">
            <div>{{formatAmount(row.avgStake)}}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-if="queryData.keyType != 1 && queryData.keyType != 6 && queryData.keyType != 7">
      <el-table
        ref="table"
        :data="list"
        :height="tableHeight"
        v-loading="loading"
        :key="2"
        header-row-class-name="table-header-row"
        border
      >
        <template slot="empty">
          <Empty />
        </template>
        <el-table-column
          label="Sport"
          prop="content"
          min-width="236"
          class-name="table-font-bold"
          v-if="queryData.keyType == 2"
        ></el-table-column>
        <el-table-column
          label="Tournament"
          min-width="158"
          class-name="table-font-bold"
          v-if="queryData.keyType == 3"
        >
          <template v-slot="{ row }">
            <div>
              <div>{{ row.content }}</div>
              <div>{{(row.remark)}}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Market"
          min-width="158"
          class-name="table-font-bold"
          v-if="queryData.keyType == 4"
        >
          <template v-slot="{ row }">
            <div>
              <div>{{ row.content }}</div>
              <div>{{(row.remark)}}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Pre-Match/Inplay"
          prop="content"
          min-width="158"
          class-name="table-font-bold"
          v-if="queryData.keyType == 5"
        ></el-table-column>
        <el-table-column label="Stake" sortable prop="totalStake" align="right" min-width="158"></el-table-column>
        <el-table-column label="P/L" sortable prop="totalProfit" align="right" min-width="158"></el-table-column>
        <el-table-column label="P/L%" align="right" min-width="153">
          <template v-slot="{ row }">
            <span v-if="row.totalProfitPercent">{{ row.totalProfitPercent }}%</span>
          </template>
        </el-table-column>
        <el-table-column
          label="Settled Stake"
          sortable
          prop="totalSettleStake"
          align="right"
          min-width="157"
        ></el-table-column>
        <el-table-column label="Stake Percent" align="right" min-width="156">
          <template v-slot="{ row }">
            <span v-if="row.totalStakePercent">{{ row.totalStakePercent }}%</span>
          </template>
        </el-table-column>
        <el-table-column label="Bets" sortable prop="betCount" align="right" min-width="157"></el-table-column>
        <el-table-column label="Bets Percent" align="right" min-width="155">
          <template v-slot="{ row }">
            <span v-if="row.betCountPercent">{{ row.betCountPercent }}%</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-if="queryData.keyType == 7">
      <el-table
        ref="table"
        :data="list"
        :height="tableHeight"
        v-loading="loading"
        :key="7"
        header-row-class-name="table-header-row"
        border
      >
        <template slot="empty">
          <Empty />
        </template>
        <el-table-column
          label="Order Risk Tag"
          prop="content"
          min-width="158"
          class-name="table-font-bold"
        ></el-table-column>
        <el-table-column label="Bets" sortable prop="betCount" align="right" min-width="157"></el-table-column>
        <el-table-column label="Stake" sortable prop="totalStake" align="right" min-width="158"></el-table-column>
        <el-table-column
          label="Settled Stake"
          sortable
          prop="totalSettleStake"
          align="right"
          min-width="157"
        ></el-table-column>
        <el-table-column label="P/L" sortable prop="totalProfit" align="right" min-width="158"></el-table-column>
        <el-table-column label="P/L%" align="right" min-width="153">
          <template v-slot="{ row }">
            <span v-if="row.totalProfitPercent">{{ row.totalProfitPercent }}%</span>
          </template>
        </el-table-column>
        <el-table-column label="Risk Bets%" align="right" min-width="153">
          <template v-slot="{ row }">
            <span v-if="row.betCountPercent">{{ row.betCountPercent }}%</span>
          </template>
        </el-table-column>
        <el-table-column label="Risk Stake%" align="right" min-width="153">
          <template v-slot="{ row }">
            <span v-if="row.totalStakePercent">{{ row.totalStakePercent }}%</span>
          </template>
        </el-table-column>
        <el-table-column label="Coushout Stake" prop="cashoutStake" align="right" min-width="158"></el-table-column>
        <el-table-column label="Coushout P/L" prop="cashoutCount" align="right" min-width="158"></el-table-column>
        <el-table-column label="Coushout Bets" prop="cashoutProfit" align="right" min-width="158"></el-table-column>
      </el-table>
    </div>
    <div v-if="queryData.keyType == 6" class="terminal-wrapper">
      <div class="device-table">
        <el-table
          ref="table"
          :data="list"
          :height="tableHeight"
          v-loading="loading"
          :key="3"
          header-row-class-name="table-header-row"
          border
        >
          <template slot="empty">
            <Empty />
          </template>
          <el-table-column
            label="Device"
            prop="terminal"
            class-name="table-font-bold"
            min-width="200"
          ></el-table-column>
          <el-table-column label="Bet Count" prop="betCount" align="right" min-width="200"></el-table-column>
          <el-table-column label="Precent" align="right" min-width="200">
            <template v-slot="{ row }">
              <div>{{ row.percent }}%</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div id="main" style="width:50%;height:185px"></div>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
import Empty from "@/components/empty/index";

import {
  getBetInfo,
  getBetChildInfo,
  getBetTerminal
} from "@/api/memberDetail";
export default {
  props: {
    handleCheckHistoryStatus: {
      type: Boolean
    },
    handleCheckUserInfoStatus: {
      type: Boolean
    }
  },
  data() {
    return {
      list: [],
      totalList: [],
      terminal: [],
      series: [],
      fastData: "",
      freeDate: [],
      firstActive: false,
      loading: false,
      queryData: {
        userId: 0,
        seriesType: null,
        startTime: new Date(new Date().toLocaleDateString()).getTime(),
        endTime:
          new Date(new Date().toLocaleDateString()).getTime() +
          24 * 60 * 60 * 1000 -
          1,
        keyType: "1"
      },
      tableHeight: window.innerHeight
    };
  },
  watch: {
    handleCheckHistoryStatus(val) {
      if (val) {
        this.$nextTick(() => {
          let self = this;
          self.tableHeight =
            window.innerHeight - self.$refs.table.$el.offsetTop - 64 + 150;
        });
      } else {
        this.$nextTick(() => {
          let self = this;
          self.tableHeight =
            window.innerHeight - self.$refs.table.$el.offsetTop - 64 - 150;
        });
      }
    },
    handleCheckUserInfoStatus(val) {
      if (val) {
        this.$nextTick(() => {
          let self = this;
          self.tableHeight =
            window.innerHeight - self.$refs.table.$el.offsetTop - 64 + 115;
        });
      } else {
        this.$nextTick(() => {
          let self = this;
          self.tableHeight =
            window.innerHeight - self.$refs.table.$el.offsetTop - 64 - 115;
        });
      }
    }
  },
  methods: {
    formatAmount(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    async getList(rightTime) {
      // console.log(this.offset)
      // console.log(this.offset * 60 * 1000 + 4 * 60 * 60 * 1000)
      !rightTime
        ? (this.queryData.startTime =
            this.queryData.startTime -
            this.offset * 60 * 1000 +
            4 * 60 * 60 * 1000)
        : this.queryData.startTime;
      !rightTime
        ? (this.queryData.endTime =
            this.queryData.endTime -
            this.offset * 60 * 1000 +
            4 * 60 * 60 * 1000)
        : this.queryData.endTime;
      this.queryData.userId = this.$route.query.userId;
      this.loading = true;
      try {
        const res = await getBetInfo(this.queryData);
        const data = res.data || {};
        this.list = data.dataList || [];
        this.totalList = data.totalData || [];
        this.loading = false;
      } catch (error) {
        this.list = [];
        this.loading = false;
      }
    },
    async getChildList(rightTime) {
      !rightTime
        ? (this.queryData.startTime =
            this.queryData.startTime -
            this.offset * 60 * 1000 +
            4 * 60 * 60 * 1000)
        : this.queryData.startTime;
      !rightTime
        ? (this.queryData.endTime =
            this.queryData.endTime -
            this.offset * 60 * 1000 +
            4 * 60 * 60 * 1000)
        : this.queryData.endTime;
      this.queryData.userId = this.$route.query.userId;
      this.loading = true;
      try {
        const res = await getBetChildInfo(this.queryData);
        const data = res.data || {};
        this.list = data || [];
        this.loading = false;
      } catch (error) {
        this.list = [];
        this.loading = false;
      }
    },
    async getTerminalList(rightTime) {
      !rightTime
        ? (this.queryData.startTime =
            this.queryData.startTime -
            this.offset * 60 * 1000 +
            4 * 60 * 60 * 1000)
        : this.queryData.startTime;
      !rightTime
        ? (this.queryData.endTime =
            this.queryData.endTime -
            this.offset * 60 * 1000 +
            4 * 60 * 60 * 1000)
        : this.queryData.endTime;
      this.queryData.userId = this.$route.query.userId;
      this.loading = true;
      try {
        const res = await getBetTerminal(this.queryData);
        const data = res.data || {};
        this.list = data || [];
        this.terminal = this.list.map(el => el.terminal);
        for (var item in this.list) {
          this.series.push({
            name: data[item].terminal,
            value: data[item].percent
          });
        }
        this.loading = false;
      } catch (error) {
        this.list = [];
        this.loading = false;
      }
    },
    handleClear() {
      this.queryData = {
        ...this.queryData,
        seriesType: null
      };
    },
    handleClick() {
      this.handleClear();
      this.handleGetList(true);
    },
    handleGetList(rightTime) {
      if (this.queryData.keyType == 1) {
        this.getList(rightTime);
      } else if (this.queryData.keyType != 1 && this.queryData.keyType != 6) {
        this.getChildList(rightTime);
      } else {
        this.getTerminalList(rightTime);
      }
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      let arry = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Total";
          return;
        } else if (index === 4 || index === 8) {
          sums[index] = `${this.totalList[column.property]}%`;
        } else {
          if (!this.list.length) {
            return;
          }
          sums[index] = this.formatAmount(this.totalList[column.property]);
        }
      });
      return sums;
    },
    fastDataChange(time) {
      this.firstActive = false;
      let d = [];
      if (time === "Today") {
        d = [
          new Date(new Date().toLocaleDateString()).getTime(),
          new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 -
            1
        ];
      }
      if (time === "7 days") {
        d = [
          new Date(new Date().toLocaleDateString()).getTime() -
            6 * 24 * 60 * 60 * 1000,
          new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 -
            1
        ];
      }
      if (time === "3 days") {
        d = [
          new Date(new Date().toLocaleDateString()).getTime() -
            2 * 24 * 60 * 60 * 1000,
          new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 -
            1
        ];
      }

      this.freeDate = d;
      this.queryData.startTime = d[0];
      this.queryData.endTime = d[1];
      this.handleGetList(false);
    },
    dataTimeChange([startTime, endTime]) {
      this.firstActive = false;
      this.queryData.startTime = startTime;
      this.queryData.endTime = endTime;
      this.fastData = "";
      this.handleGetList(false);
    },
    handleTotal(num) {
      this.queryData.seriesType = num;
      this.handleGetList(true);
    },
    // 饼图
    getPie() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById("main"));
      // 绘制图表，this.echarts1_option是数据
      let option = {
        series: {
          type: "pie",
          radius: "60%",
          center: ["65%", "60%"], //距离左右，上下距离的百分比
          hoverAnimation: false, // 是否开启 hover 在扇区上的放大动画效果
          label: {
            normal: {
              formatter: "{b}  {d}% ",
              color: "#000"
            }
          },
          data: this.series
        },
        tooltip: {
          formatter: "{b} : {c}%" // 默认值null，内容格式器
        },
        color: [
          "#6DA0FD",
          "#84CACA",
          "#89C97A",
          "#EED159",
          "#FFA07A",
          "#BA55D3"
        ],
        legend: {
          orient: "vertical",
          x: "3%",
          y: "5%",
          margin: [50, 0, 0, 0],
          textStyle: {
            color: "#000"
          },
          icon: "circle",
          itemWidth: 6,
          itemHeight: 6,
          itemGap: 19, //间距
          selectedMode: false, //取消图例上的点击事件
          data: this.terminal
        }
      };
      //配置图表数据及配置项
      myChart.setOption(option);
      //根据浏览器大小改变大小
      window.onresize = () => {
        myChart.resize();
        //如果有多个表变动在下方依次写下去就可以了
      };
      this.series = [];
    }
  },
  updated() {
    // 获取Echarts数据，放在mounted里不显示
    this.queryData.keyType == 6 ? this.getPie() : "";
    this.$nextTick(() => {
      this.$refs["table"].doLayout();
    });
  },
  components: {
    Empty
  },
  mounted() {
    this.offset = new Date().getTimezoneOffset();
    let d = [];
    d = [
      new Date(new Date().toLocaleDateString()).getTime() -
        30 * 24 * 60 * 60 * 1000,
      new Date(new Date().toLocaleDateString()).getTime() +
        24 * 60 * 60 * 1000 -
        1
    ];
    this.freeDate = d;
    this.queryData.startTime = d[0];
    this.queryData.endTime = d[1];
    this.getList(false);
    this.$nextTick(() => {
      let self = this;
      self.tableHeight =
        window.innerHeight - self.$refs.table.$el.offsetTop - 64;
      window.onresize = function() {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 64;
      };
    });
  }
};
</script>

<style lang="scss" scoped>
.bettinfo-date {
  font-size: 12px;
  margin: 0 0 15px 0;
  .date-left {
    width: 80%;
  }
  .date-right {
    width: 20%;
  }
}
.single-parlay-total {
  margin: 5px 0 20px;
}
.middle-btn {
  margin: 0px 0 15px;
}
.terminal-wrapper {
  font-size: 0;
  .device-table,
  #main {
    display: inline-block;
    vertical-align: top;
    background: #fbfbfc;
  }
  .device-table {
    width: calc(50% - 10px);
    margin-right: 10px;
  }
  #main {
    border-radius: 10px;
  }
}
</style>
